/* import BpHistoryHeader from "../Header/BpHistoryHeader"; */
import { Link, useParams } from "react-router-dom";
import TagpayIcon from "../../assets/tagpay.png"
import PaidIcon from "../../assets/paidicon.png"
import Refundicon from "../../assets/refund.png"
import WaitingLoder from "../../WaitingLoader/component";
import "../TagpayHistory/tagpay.css"
import TagIcon from "../../assets/tagpay.png"
import changeArrow from "../../assets/changeArrow.png";
import RechargeSuccess from '../../assets/rechargeSuccess.png'
import TagHistory from "./2";
import { useNavigate } from "react-router-dom";
import RechargeModal from "./RechargeModel";
import TransactionHistory from "./3";
const TagpayHistory=(props)=>{
  const navigate=useNavigate()
  const { uId } = useParams();

  console.log("UUID:", uId); // 0035968753
  function TruncatedOrderId({ text, limit }) {
    if (text&&text.length <= limit) {
      return <>{text}</>;
    }
    return <>{`${text.substring(0, limit)}...`}</>;
  }
   //console.log("props rechargeModal",props.rechargeModal)
 


const handleAmount=(e)=>{

//console.log("handleAmount",e.target.value)
props.setAmount(e.target.value)

}

const handleSetelectAmount=(e,amount)=>{
  props.setAmount(e.target.value)
  props.setAmount(amount)
}

const goToRechargePaymentOption=()=>{
  //localStorage.setItem("goToRechargePaymentOption",)
 navigate(`/paymentOptions?route=taghistory/${uId}`)

}

 const handleRoute=()=>{
    
  }

const CloseRechargeModal=()=>{
  props.setRechargeModal(false)
  localStorage.removeItem("ChangeRechageMethod")
}

//console.log("props&&props.tagDeatils&&props.tagDeatils.cardType",props&&props.tagDeatils&&props.tagDeatils.cardType)

    return(
    <>
       {true?
    <>
     
       {props.loader && <WaitingLoder />} 
      <TagHistory cardType={props&&props.tagDeatils&&props.tagDeatils.cardType} balance={props&&props.tagDeatils&&props.tagDeatils.balance&&props.tagDeatils.balance.toFixed(2)}  setRechargeModal={props&&props.setRechargeModal} DeactiveModal={props.DeactiveModal}/>
          <TransactionHistory tagListHistory={props&&props.tagListHistory} />

      {(props&&props.rechargeModal)&&
<>
   {
       <RechargeModal
        rechargeModal={(props&&props.rechargeModal)}
        CloseRechargeModal={() =>props&&props.setRechargeModal(false)}
        handleAmount={handleAmount}
        handleSetelectAmount={props&&props.handleSelectAmount}
        goToRechargePaymentOption={goToRechargePaymentOption}
        AddIntoCart={props&&props.AddIntoCart}
        amount={props&&props.amount}
        setAmount={props.setAmount}
      />}
</>
}


      {props.deactiveModal&&<div  className="modalDeactive"  /* style={{width:"90%",top:"20%", height:"392px",left:"5%"}} */ >
        <div style={{display:"flex",justifyContent:"center"}}>
        <div className="modal-content-tagHistory">
          <img src={TagIcon} style={{"margin-left":"37%"}} />
          <h3 style={{"text-align":"center"}}>De-activate Tag?</h3>
          <p style={{ "text-align":"center","margin-top": "11px"}}>You won’t be able to use the tag after deactivation. For activating again, you will need the tag’s secret code.</p>
         <p style={{ "text-align":"center","margin-top": "11px","font-weight":"bold"}}>Your remaining balance ₹{props&&props.tagDeatils&&props.tagDeatils.balance.toFixed(2)} will be transferred to Daalchini Points.</p>
          
          <div style={{display:"flex","justify-content":"space-around","margin-top": "8px"}}>
          <button onClick={(e)=>{props.setDeactiveModal(false)}} className="canclebtn">Cancel</button>
            <button onClick={props.Deactive} className="deactivebtn">De-activate</button>
          </div>
          </div>
          </div>
        </div>}

        {(props.rechargeSucessModal)&&<div  className="RechargeSuccessmodal"  /* style={{width:"90%",top:"20%", height:"392px",left:"5%"}} */ >
        <div className="modal-content-RechargeSuccessmodal">
         <div style={{display:"flex","justify-content":"space-around"}}> <img src={RechargeSuccess} style={{"width":"72px"}} /></div>
          <h3 style={{"text-align":"center",color: "var(--neutral-01, #333F4E)","font-family":"Roboto",
"font-size": "20px",
"font-style":"normal",
"font-weight": "700",
"line-height": "normal",marginTop:"11px"}}>Success</h3>
          <p style={{ "text-align":"center","margin-top": "21px"}}>Tag has been successfully recharged with ₹{props&&props.amount}</p>
          
          <div style={{display:"flex","justify-content":"space-around","margin-top": "27px"}}>
          <button style={{display: "flex",
"height": "43px",
"padding":"11px 24px",
"justify-content": "center",
"align-items":"center",
"gap": "10px",
/* "flex":"1 0 0", */
"border-radius":"12px",
color:"white",
width:"50%",
"background": "var(--primary-5, #00B177)"}} onClick={(e)=>{props.setRechargeSucessModal(false)}}>OK</button>
          </div>
          </div>
        </div>}





    
    </>:<></>}
    </>
    )
}

export default TagpayHistory;